(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2822],{

/***/ 67196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/poshmark-vacation-mode/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2021-07-23",
      tag: "Poshmark",
      title: "Poshmark Sellers Guide to Poshmark Vacation Mode",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Are you a Poshmark seller and are planning a vacation? Or just want to get your closet on hold for a while? Poshmark Vacation Mode is the perfect solution.", ' ']
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What is Poshmark Vacation Mode?"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Poshmark Vacation Mode is a tool that allows you to put your Poshmark account closet on hold and then easily turn it back on the platform when you're ready. You can use this mode for anything from taking time off of work, going on vacation, or just not having access to the internet for a period of time."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["When you put your listing on vacation hold, you can hide and block purchases while you are away. However, buyers can still view, like, comment, and share it on the platform.", ' ']
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Is there a Vacation Mode on Poshmark?"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Poshmark allows their seller to put their listings as Not For Sale temporarily due to vacation, taking a break, and any other personal reasons. In this way, Poshmark sellers can pause their listings if they cannot ship them within the given time or are busy doing something else. But keep in mind the if you pause your closet, it also means that you are also halting your sales."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How can I set up a Poshmark Vacation Mode?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "On Desktop / Laptop:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tap on your profile image located at the top right page "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click on your Account Settings menu"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click the drop-down menu, then select Poshmark Support Center"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tap your setting tab, then choose Vacation Hold"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Toggle the ON button to set your desired dates "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Enter the start date and return date "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Click the Save button to save changes "
        })]
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "In Poshmark App: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to your account tab (ex. @account_name)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tap the My Seller Tools"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to your account settings menu, then Select Vacation Hold. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Toggle the ON button to set your desired dates"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Enter the start date and end date "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Don\u2019t forget to click the Save button to save changes, and you\u2019re good to go! "
        })]
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "When to Turn On My Poshmark Closet Vacation Mode?"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "You're about to embark on a much-needed vacation. You've packed your suitcase, bought the plane tickets, and now you need to figure out what to do with your closet. What if someone buys something from your Poshmark account while you're gone? Can't they just return it when they receive it? The answer is no!"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Aside from it is impractical to bring along with you all the items you listed, pack and bring them to the nearby post office if you made a sale, you\u2019ll never get to enjoy your vacation fully. So, when do you put your closet on hold?"
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The answer is simple - If you will be out of town for more than five days, it\u2019s better to set your closet temporarily on hold to avoid your buyer from waiting on when you can ship the package. If you can\u2019t send the parcel within seven days from the date of purchase, the buyer can cancel the sale. Plus, you can\u2019t expect buyers to give you a 5-star rating due to late shipments."
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "I\u2019m Back Home! How Can I Re-activate My Poshmark Closet?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["All you have to do is toggle Vacation Mode off to re-activate all your available listings. This means that they will be viewed as available or For Sale again. You can also reach out to customers who commented or message you during your vacation to let them know that the item they inquire about is now available for purchase.", ' ']
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When you get back, make sure to take a picture of the item you want to sell. Try to photograph it from many angles and create a brief description of the item, including its current condition and flaws. Select the appropriate category, variations, sizes, and color from the menu. You can also check out other sellers\u2019 listing prices with the same product to create competitive listing prices and reach more buyers."
      }), "\u200B \u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Important Things to Keep in Mind"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "All new listings will be set to Available even if your closet is on vacation mode. You may manually set it to Not For Sale through the edit listing page."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Your listings can still receive views, likes, comments and can be shared even if you put your closets on hold.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["You can still respond to your buyer\u2019s questions even while on vacation. But it is still totally up to you whether you want to respond to your customer\u2019s questions or not. You can always catch up on them when you get back from your vacation.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Reinstate your product description when your items are available again, and politely ask your customers if they are still interested in buying your item when you get back home.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Suppose you decide to ship a package even if you are on vacation and the package is lost or stolen while in transit. Keep calm! As long as you used the Poshmark-provided shipping label and it was scanned in the USPS tracking system, Poshmark will cover the amount completely."
        })]
      }), "\u200B \u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What do I do from here?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["It's perfectly OK to step away to avoid burning out and refresh your mind to get ready for you next big sale and future challenges! We at OneShop understand how important it is to maintain and grow your earnings even if you do decide to take a breather for a while. Our all-in-one platform allows you to do more with less time by automating your Poshmark tasks and helping you expand to new marketplaces.", ' ']
      }), "\u200B", /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "We help you sell faster by reaching out to more buyers ready to purchase from your closet with our Poshmark automation tools. Focus more on growing, earning, and achieving your business goals with OneShop! Sign-up today for a 7-day, commitment-free trial!"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/poshmark-vacation-mode.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Poshmark Vacation Mode - Poshmark Sellers Guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Take a breather and learn how to pause your business while you are away!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/poshmark-vacation-mode"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/poshmark-vacation-mode"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Poshmark Vacation Mode - Poshmark Sellers Guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Take a breather and learn how to pause your business while you are away!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2021-07-23T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2021-07-23T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 72284:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/poshmark-vacation-mode",
      function () {
        return __webpack_require__(67196);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(72284); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);